import React from 'react';
import Box from '@mui/material/Box'
import { Outlet } from "react-router";
import Nav from "./Nav"
import Container from "@mui/material/Container";
import Footer from "./Footer";

function Layout() {
    return (
        <Box>
            <Nav />
            <Box component="main" sx={{ flexGrow: 1, minHeight: '100vh', pb: 4 }}>
                <Container sx={{ mt: 4, mb: 4 }}>
                    <Outlet />
                </Container>
            </Box>
            <Footer />
        </Box>
    );
}

export default Layout;
